module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_inkminkm_m.43efecb14ae1cac93236965f086a42cb.png";